import { useCallback, useEffect, useRef, useState } from 'react';
import { ICrmActivity } from 'services/CrmApi/types/CrmActivityTypes';

export const useEditActivity = (
  activity: ICrmActivity,
  isHighlighted: boolean,
  setIsExpanded: (value: boolean) => void
) => {
  const [editModalOpen, setConfirmationModalOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isHighlighted) {
      const threshold = 135; // 135px is the height of the header
      const offsetTop = (ref.current?.offsetTop ?? 0) - threshold;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  }, [isHighlighted, activity]);

  useEffect(() => {
    setIsExpanded(isHighlighted);
  }, [isHighlighted, setIsExpanded]);

  const handleOpenEditModal = () => {
    setConfirmationModalOpen(true);
  };

  const handleCancelEdit = useCallback(() => {
    setConfirmationModalOpen(false);
  }, []);

  const handleEditTabTask = (taskId: string, directoryEntryId: string) => {
    window.open(`/tasks/${taskId}/edit?openedBy=${directoryEntryId}`, '_blank');
  };

  return {
    editModalOpen,
    ref,
    handleOpenEditModal,
    handleCancelEdit,
    handleEditTabTask,
  };
};
